/**
 * Product detail drawer — one instance per detail panel. A trigger pill calls
 * document.getElementById(id).open(). Slides in from the right. Closes on
 * Escape, the close button, or any click outside the inner panel (overlay).
 */
if (!customElements.get('detail-drawer')) {
  class DetailDrawer extends HTMLElement {
    constructor() {
      super();
      this._boundKeydown = this._handleKeydown.bind(this);

      // Listener lives on the element itself, so it survives being moved to
      // <body> on open() with no re-binding. Close on the close button or any
      // click that isn't inside the inner panel.
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-dd-close]')) {
          this.close();
          return;
        }
        if (!e.target.closest('.dd-drawer__inner')) {
          this.close();
        }
      });
    }

    _handleKeydown(e) {
      if (e.key === 'Escape') this.close();
    }

    open() {
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this._boundKeydown);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.add('active'));
      });
      const closeBtn = this.querySelector('[data-dd-close]');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      this.classList.remove('active');
      document.removeEventListener('keydown', this._boundKeydown);
      const inner = this.querySelector('.dd-drawer__inner');
      if (inner) {
        inner.addEventListener('transitionend', () => {
          document.body.style.overflow = '';
        }, { once: true });
      } else {
        document.body.style.overflow = '';
      }
    }
  }

  customElements.define('detail-drawer', DetailDrawer);
}
